import { Button, Form } from 'antd';
import { useCreateSupplier } from 'features/master/use-cases/create-supplier';
import { useGetMaterialCommonList } from 'features/material-details/use-cases/get-commonmasterlist';
import { UserFormField, UserFormValues } from 'features/users/components/users-filter-form';
import { useEffect, useState } from 'react';

import { SupplierInfoFormItems } from './supplier-info-form-items';

export const SupplierModalView = ({ onClose, userEditData ,addOrEdit,setUserEditData}: { onClose: () => void, userEditData: any,addOrEdit:number,
    setUserEditData: React.Dispatch<React.SetStateAction<any>>
}) => {
    const formName = 'add-user-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<UserFormValues>();
    const { isLoading, mutate } = useCreateSupplier();
    const [selectedType, setSelectedType] = useState<string>("");      

    const handleSubmit = (formValues: any) => {
        const isEdit = !!userEditData?.id;
        const payload: any = {
            flag: isEdit ? "Upsert" : "Upsert",
            title: formValues?.title,
            description: formValues?.description,
            type:(formValues.type=="Sales")?1:(formValues.type=="Purchase")?2:formValues.type
        };

        if (userEditData?.id && addOrEdit!=1) {
            payload.id = userEditData.id;
        }
        mutate(payload, { onSuccess: handleClose });
           setUserEditData(undefined);
      
    }

    const handleClose = () => {
        onClose();
        form.resetFields();
    }
    useEffect(() => {
        if (userEditData) {
            userEditData.role = parseInt(userEditData.role);
            form.setFieldsValue(userEditData);
        } else {
            form.resetFields();
        }

    }, [userEditData, form]);

    const getInitialValues = {
        [UserFormField.FirstName]: undefined,
        [UserFormField.PhoneNumber]: undefined,
        [UserFormField.Role]: undefined,
        [UserFormField.Email]: undefined,

    };
    const commonFlags = {    
      supplierTypeList : "SupplierType" // Purchase => Material Names
    };
  
    // Determine active type for rendering fields

  
    // Fetch Material Types (Sales / Purchase)
    const { data: supplierType } = useGetMaterialCommonList({
      Flag: commonFlags.supplierTypeList,
    } as any);
    
    
return (
        <>
            <div className={'popup'}>
                <div className='modal_head'>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                    <h4>{ (userEditData?.id)? 'Edit Customer / Supplier' : 'Add Customer / Supplier'}</h4>
                </div>
                <div className='modal_body'>
                    <Form<UserFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={getInitialValues}
                        onFinish={handleSubmit as any}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <SupplierInfoFormItems   
                        supplierType={supplierType}                                       
                        setSelectedType={setSelectedType}
                        selectedType={selectedType}
                        />

                        <div className='form-button'>
                            <Button type="primary" htmlType='submit' className="btn" >Save</Button>
                        </div>
                    </Form>
                </div>
            </div>

        </>
    );
};

